import { AsyncPipe } from '@angular/common';
import { Component, Signal, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LoadingService } from '../../../core/services/loading/loading.service';
import { PaymentDetailsActionBarComponent } from '../../../modules/application/orders/shared/components/payment-details-action-bar/payment-details-action-bar.component';
import { UserStateService } from '../../../modules/user/shared/services/user-state/user-state.service';
import { HeaderComponent } from '../../components/header/header.component';
import { LoadingComponent } from '../../components/loading/loading.component';
import { MasqueradeHeaderComponent } from '../../components/masquerade-header/masquerade-header.component';
import { SidenavComponent } from '../../components/sidenav/sidenav.component';

@Component({
    selector: 'app-payment-details-layout',
    templateUrl: './payment-details-layout.component.html',
    styleUrls: ['./payment-details-layout.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        HeaderComponent,
        RouterModule,
        SidenavComponent,
        MasqueradeHeaderComponent,
        AsyncPipe,
        LoadingComponent,
        PaymentDetailsActionBarComponent,
    ],
})
export class PaymentDetailsLayoutComponent {
    loading$ = this.loadingService.loading$;
    isMasqueraded: Signal<boolean> = this.userStateService.isMasqueraded;

    constructor(
        private readonly loadingService: LoadingService,
        private readonly userStateService: UserStateService,
    ) {}
}
